import { type KeyboardEvent } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Button, Error, Typography } from 'shared/ui'
import { makeTextFieldAutoFocus, makeTextFieldHighlight, TextField } from 'shared/ui/TextField'
import { Label } from 'shared/ui/Label'
import { uiStore } from 'shared/store/uiStore'
import { type ForgotPasswordStore } from 'pages/auth/pages/forgot/ui/ForgotPassword'
import { AuthPath } from 'pages/auth/route/authPath'
import styles from './styles.module.scss'

type IFormProps = {
  store: ForgotPasswordStore
}

export const ForgotPasswordForm = observer(({ store }: IFormProps) => {
  const {
    setEmail,
    email,
    loading,
    emailError,
    emailValidationError,
    triggerEmailValidation,
    isValidEmail,
  } = store

  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      triggerEmailValidation()
    }
  }

  const onSignIn = () => {
    uiStore.changeRoute({
      path: `/${AuthPath.login}`,
    })
  }

  return (
    <div className={styles.wrap}>
      <Label
        label={{
          text: 'Email address',
          className: styles.inputLabel,
        }}
      />
      <TextField
        className={classNames(styles.textField, {
          [styles.error]: !!emailError || !!emailValidationError,
        })}
        variant='stroke'
        disabled={loading}
        size='medium'
        error={!!emailError}
        InputProps={{ placeholder: 'name@company.com', onKeyDown }}
        onChange={setEmail}
        value={email}
        mainActions={[
          makeTextFieldAutoFocus({ withFocus: true }),
          makeTextFieldHighlight({ mode: 'error', highlight: !!emailValidationError }),
        ]}
      />
      <Error type={'text'} error={emailError || emailValidationError} />

      <Button
        className={styles.button}
        typeBtn='contained'
        type='button'
        onClick={triggerEmailValidation}
        loading={loading}
        disabled={loading || !isValidEmail}
        text={'Send instructions'}
        contained={'primary'}
        fullWidth
      />

      <div className={styles.bottom}>
        <Typography
          variant={'body-sm-medium'}
          ariaLabel={'signInLink'}
          color={'var(--content-primary-tertiary)'}
        >
          Already have a Salesmsg account?
          <Button onClick={onSignIn} typeBtn={'link'} text={'Sign in'} />
        </Typography>
      </div>
    </div>
  )
})

export default ForgotPasswordForm
